module.exports = __webpack_public_path__ + "img/company1.png";